/*
 * ke-device-compare — before/after divider.
 *
 * The range input alone was not enough: a native range only tracks when you grab its thumb,
 * and the thumb here is invisible, so on touch you had to land exactly on the divider for a
 * drag to register. Anywhere else did nothing, which felt broken.
 *
 * So pointer events drive the drag directly on the stage — press anywhere and it jumps, then
 * follows the finger. The range stays in the DOM purely as the keyboard/screen-reader control.
 */
(function () {
  'use strict';

  function bind(stage) {
    var range = stage.querySelector('[data-ke-compare-range]');
    var after = stage.querySelector('[data-ke-compare-after]');
    var handle = stage.querySelector('[data-ke-compare-handle]');
    if (!after) return;

    var dragging = false;
    var startX = 0;
    var startY = 0;
    var decided = false;

    function paint(pct) {
      var pos = pct + '%';
      after.style.setProperty('--ke-cmp-pos', pos);
      if (handle) handle.style.setProperty('--ke-cmp-pos', pos);
      if (range) range.value = pct;
    }

    function pctFromX(clientX) {
      var r = stage.getBoundingClientRect();
      var pct = ((clientX - r.left) / r.width) * 100;
      return Math.max(0, Math.min(100, Math.round(pct)));
    }

    stage.addEventListener('pointerdown', function (e) {
      // Deliberately does NOT paint yet. Painting on press meant a vertical scroll gesture
      // that merely started on the stage yanked the divider to wherever the finger landed.
      // The position is committed once the gesture is known to be horizontal, or on release
      // if it was a stationary tap.
      dragging = true;
      decided = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;

      // Decide once whether this gesture is a horizontal drag or a vertical page scroll.
      // Claiming the pointer immediately would make the section impossible to scroll past
      // on a phone; releasing it on vertical movement keeps the page scrollable.
      if (!decided) {
        var dx = Math.abs(e.clientX - startX);
        var dy = Math.abs(e.clientY - startY);
        if (dx < 6 && dy < 6) return;
        decided = true;
        if (dy > dx) {
          // Vertical intent: let the page scroll and leave the divider untouched.
          dragging = false;
          return;
        }
        stage.classList.add('is-dragging');
        if (stage.setPointerCapture) {
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        }
      }
      e.preventDefault();
      paint(pctFromX(e.clientX));
    });

    function end(e) {
      if (!dragging) return;
      // A press with no meaningful movement is a tap — jump the divider there.
      if (!decided && e && typeof e.clientX === 'number') paint(pctFromX(e.clientX));
      dragging = false;
      stage.classList.remove('is-dragging');
      if (e && e.pointerId != null && stage.releasePointerCapture) {
        try { stage.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('pointerleave', end);

    // Keyboard: arrows on the focused range still work.
    if (range) range.addEventListener('input', function () { paint(parseInt(range.value, 10)); });

    paint(range ? parseInt(range.value, 10) : 50);
  }

  function init() {
    document.querySelectorAll('[data-ke-compare]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
